var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " m-relatedCompaniesItem__infoContainer--hasJobs";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"m-relatedCompaniesItem__jobCount\" data-hasjobs=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hasJobs") : depth0), depth0))
    + "\" data-count=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"count") : depth0), depth0))
    + "\"\n                             data-hasonejob=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hasOneJob") : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"count") : depth0), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasOneJob") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":7,"column":70},"end":{"line":8,"column":34}}})) != null ? stack1 : "")
    + "</span>";
},"4":function(container,depth0,helpers,partials,data) {
    return "\n            Job";
},"6":function(container,depth0,helpers,partials,data) {
    return "Jobs";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a class=\"m-relatedCompaniesItem\" href=\"/f/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"slug") : depth0), depth0))
    + "\" data-slug=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"slug") : depth0), depth0))
    + "\" data-event=\"click: related-company\">\n"
    + ((stack1 = container.invokePartial(require("../companyCardImageLight/template.hbs"),(depth0 != null ? lookupProperty(depth0,"companyCardImageLight") : depth0),{"name":"module/companyCardImageLight/template","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    <div class=\"m-relatedCompaniesItem__infoContainer "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasJobs") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":54},"end":{"line":4,"column":71}}})) != null ? stack1 : "")
    + "\">\n        <h3 class=\"m-relatedCompaniesItem__title\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "</h3>\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasJobs") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":8,"column":48}}})) != null ? stack1 : "")
    + "\n    </div>\n</a>\n";
},"usePartial":true,"useData":true});